export default {
    userInfoTitle: 'Min kontaktinformasjon',
    userInfoFormTitle: 'Oppdater kontaktinformasjon',
    userInfoIngress: 'Vi finner følgende informasjon om deg. Du kan enkelt endre det her.',
    userInfoLabelEmail: 'E-post',
    userInfoLabelMobile: 'Mobil',
    userInfoLabelMobileFull: 'Mobilnummer',
    userInfoLabelAddress: 'Adresse',
    userInfoNoCustomer: 'Vi finner ingen kontaktinformasjon på deg. Ta kontakt med Eika Kundesenter.',
    userInfoUpdated: 'Kontaktinformasjonen din har blitt oppdatert.',
    userInfoSaveButton: 'Lagre endringer',
    userInfoErrorEmailFormat: 'Ikke gyldig e-postadresse',
    userInfoErrorEmailEmpty: 'Du må fylle inn din e-postadresse',
    userInfoErrorMobileLength: 'Mobilnummer må være 8 siffer',
    userInfoErrorMobileValidation: 'Mobilnummer må kun bestå av siffer',
    userInfoErrorMobileEmpty: 'Du må fylle inn ditt mobilnummer',
    userInfoErrorCheckForm: 'Vennligst kontroller skjemaet',
    userInfoErrorUpdateFailed: 'Vi kunne dessverre ikke oppdatere informasjon om deg akkurat nå. Prøv igjen senere.',
    userInfoButtonTitle: 'Kontaktinformasjon',
    userInfoButtonDescription: 'Har du fått ny e-post eller mobilnummer?',

    userInfoErrorFetchFailed: 'Vi kunne dessverre ikke hente informasjon om deg akkurat nå. Prøv igjen senere.',
};
